import React, {useMemo, useRef, useEffect, useState} from "react";
import { BLD_TYPE_LABELS } from "../constants/bldLabels";
import SupplierInfoBlock from "./SupplierInfoBlock";
import PhotoSlot from "./PhotoSlot";
import "./Print.css";

// ===================== Gemini 구글드라이브 공유폴더 업로더 ===================== 
import { saveRentItems } from "../api/propertyApi";
import { getPhotoStorage, uploadServerPhoto, listServerPhotos, deleteServerPhoto } from "../api/propertyApi";
import { uploadPhoto } from "../api/photoStorage"; 
// import { uploadToDrive, listDriveImages, deleteDriveFile, getAccessTokenInteractive } from "../lib/gdrive";
// const accessTokenRef = useRef(null);
// ===================== Gemini 구글드라이브 공유폴더 업로더 ===================== 

// 인쇄용 정적 지도
function StaticMapBox({ center }) {
  const ref = useRef(null);
  useEffect(() => {
    const ensure = (cb)=>{
      if (window.kakao?.maps) return cb();
      const s = document.createElement("script");
      s.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=3b72256b73696ef033a88934ccd70232&libraries=services&autoload=false";
      s.async = true; s.onload = ()=> window.kakao.maps.load(cb);
      document.head.appendChild(s);
    };
    ensure(() => {
      if (!ref.current) return;
      const { kakao } = window;
      new kakao.maps.StaticMap(ref.current, {
        center: new kakao.maps.LatLng(center.lat, center.lng),
        level: center.level ?? 4,
        marker: {
          position: new kakao.maps.LatLng(center.lat, center.lng),
          text: "",
        },
      });
    });
  }, [center]);
  return <div className="map-box" ref={ref} style={{height:"100%"}} />;
}

/** props: { open, onClose, property } */
// 명시적으로 props를 분해해서 받음
export default function ProfitPrintDialog({
  open,
  property,
  onClose,
  displaySource: displaySourceProp,   // App/PropertyList에서 내려준 값
  onUpdated,
  ...rest
}) {
  const fileInputRef = useRef(null);
  const accessTokenRef = useRef(null);
  const [photoStorage, setPhotoStorage] = useState("server");
  const [serverPhotos, setServerPhotos] = useState([]);
  const [drivePhotos, setDrivePhotos] = useState([]);
  const [photoUrl, setPhotoUrl] = useState("");
  const [propState, setPropState] = useState(property || null); // 로컬 사본
  const [uploading, setUploading] = useState(false); // ← 업로드 진행상태

  // App에서 // 전달값 우선, 없으면 localStorage 기본값
  const displaySource = displaySourceProp || localStorage.getItem('photo_source') || 'server';

  // 선택된 소스에 맞춰 URL 생성
  const pickUrl = React.useCallback((estate, fallback) => {
    const fid = estate?.thumb_file_id || "";
    const surl = estate?.thumb_url || "";
    const base = displaySource === 'server'
      ? (surl || (fid ? `/api/photo-storage/${fid}/preview` : fallback || ""))
      : (fid ? `/api/photo-storage/${fid}/preview` : (surl || fallback || ""));
    return base ? `${base}${base.includes('?') ? '&' : '?'}t=${Date.now()}` : "";
  }, [displaySource]);

  // Drive URL 정규화: <img>에 안전한 썸네일 엔드포인트로 변환
  const driveIdFromUrl = (u) => {
    const s = String(u || "");
    let m = s.match(/[?&]id=([A-Za-z0-9_\-]+)/); if (m) return m[1];
    m = s.match(/\/d\/([A-Za-z0-9_\-]+)/);      if (m) return m[1];
    if (/^[A-Za-z0-9_\-]{20,}$/.test(s)) return s;
    return null;
  };
  const toImgUrl = (uOrId) => {
    const id = driveIdFromUrl(uOrId);
    // <img> 안전 표시용: 서버 프록시 사용
    return id ? `/api/photo-storage/${id}/preview` : String(uOrId || "");
  };

  // ===================== Gemini 구글드라이브 공유폴더 업로더 ===================== 
  const onClickUpload = async () => {
    if (typeof getAccessTokenInteractive !== "function") return;
    try {
      // 사용자 제스처 안에서 토큰 발급 → 팝업 허용됨
      const t = await getAccessTokenInteractive();
      accessTokenRef.current = t;
      fileInputRef.current?.click(); // 토큰 받은 뒤 파일창 오픈
    } catch (e) {
      console.error(e);
      alert("Google 인증 실패");
    }
  };


// ===================== Gemini 구글드라이브 공유폴더 업로더 ===================== 


const [dirty, setDirty] = React.useState(false); // 새 사진 교체 여부 플래그
const prevPropId = React.useRef(null);

async function onWatermarkFile(e) {
  const f = e.target.files?.[0];
  if (!f) return;
  setUploading(true);
  try {
    // 업로드 시 property id를 서버로 전달해서 서버가 즉시 DB 저장까지 수행하도록 시도
    const pid = property?.estate_no ?? property?.id;
    const up   = await uploadPhoto(f, pid);           // ← 두 번째 인자로 property id 전달
    const saved = up?.saved || null;                  // 서버가 DB에 반영했다면 {estate_no, thumb_url, thumb_file_id}
    const thumbId = saved?.thumb_file_id
                  || up?.thumbFileId
                  || up?.thumbId
                  || up?.thumb_id
                  || up?.fileId
                  || null;
    console.log("[ProfitPrintDialog] uploadPhoto result =", up);
    console.log("[ProfitPrintDialog] thumbId:", thumbId, "saved:", saved);
    if (!thumbId) throw new Error("썸네일 ID 누락");

    // 표시용 URL 조립: 서버 썸네일 우선 → 프록시 폴백, 캐시버스터 부여
    const base =
      (saved?.thumb_url || up?.serverThumbUrl || "") ||
      (thumbId ? `/api/photo-storage/${thumbId}/preview` : "");
    const finalUrl = base ? `${base}${base.includes("?") ? "&" : "?"}t=${Date.now()}` : "";


    // 서버가 DB 저장을 안 했다면(=saved 없음) 기존 PUT으로 저장
    if (pid && !saved) {
      const res = await fetch(`/api/properties/${pid}/photo-thumb`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ thumb_url: finalUrl, thumb_file_id: thumbId })
      });
      if (!res.ok) throw new Error("DB update failed");
    }

    // 프론트 상태 즉시 반영
    setPhotoUrl(finalUrl);
    setWm(prev => ({ ...prev, url: finalUrl }));
    setDirty(true); // 세션 내 덮어쓰기 방지

    console.log(`[PHOTO] Updated thumbnail → ${finalUrl} (id=${thumbId})`);
    
  } catch (err) {
    console.error(err);
    alert("업로드 실패");
  } finally {
    setUploading(false);
  }
}

// 초기 로드 시 DB의 thumb_file_id가 있으면 view URL로 조립해 사용
useEffect(() => {
  if (dirty) return; // 교체된 경우 기존 property 값으로 덮어쓰지 않음
  const fid = property?.thumb_file_id;
  if (fid) {
    const url = toImgUrl(fid);
    setPhotoUrl(url);
    setWm(prev => ({ ...prev, url: prev.url || url }));
  } else if (property?.thumb_url) {
    const url = toImgUrl(property.thumb_url);
    setPhotoUrl(url);
    setWm(prev => ({ ...prev, url: prev.url || url }));
  }
}, [property?.thumb_file_id, property?.thumb_url, dirty]);

useEffect(() => {
  if (!open) setDirty(false); // 모달 닫을 때 플래그 초기화
}, [open]);

  //Drive 목록 로딩 함수(컴포넌트 스코프에 위치해야 함)
  const refreshDriveList = async () => {
    if (typeof listDriveImages !== "function") return;
    try {
      const pid = property?.id || property?.estate_no || '';
      const files = await listDriveImages({ propertyId: pid });
      setDrivePhotos(files);
    } catch (e) {
      console.error(e);
      alert("Drive 목록 조회 실패");
    }
  };

  // 2. 파일 선택이 완료되면 실행될 핸들러
  const handleFileSelected = async (event) => {
    const file = event.target.files?.[0];
    if (event.target) event.target.value = null;
    if (!file) return;

    try {
      const pid = property?.id || property?.estate_no || '';
      if (typeof uploadToDrive !== "function") return;
      const up = await uploadToDrive({ file, propertyId: pid, token: accessTokenRef.current });
      const newPhoto = {
        id: up.id || up.file?.id,
        name: up.name || up.file?.name,
        thumb: up.thumbnailLink || up.file?.thumbnailLink,
        webViewLink: up.webViewLink || up.file?.webViewLink,
      };
      if (!newPhoto?.id) throw new Error("업로드 결과 없음");
      setDrivePhotos(prev => [newPhoto, ...prev]);


    } catch (error) {
      console.error('파일 업로드 실패:', error);
      alert(`업로드 실패: ${error.message}`);
    }
  };

  const onUploadLocal = async (e)=>{
    const f = e.target.files?.[0]; e.target.value="";
    if (!f) return;
    if (photoStorage === "gdrive") { alert("저장소가 구글드라이브로 설정되어 있습니다."); return; }
    const pid = property?.id || property?.estate_no; if (!pid) return;
    const r = await uploadServerPhoto(pid, f);
    if (r?.ok) setServerPhotos(prev=> [r.photo, ...prev]);
  };


  useEffect(() => {
    if (photoStorage !== 'gdrive') return;
    const pid = property?.id || property?.estate_no;
    if (!open || !pid) return;
    refreshDriveList();
  }, [open, photoStorage, property]);

  useEffect(()=>{ getPhotoStorage().then(d=> d?.ok && setPhotoStorage(d.storage)); },[open]);

  useEffect(()=>{ // property 변화 시 서버 사진 목록 갱신
    const pid = property?.id || property?.estate_no;
    if (!pid || photoStorage!=="server") return;
    listServerPhotos(pid).then(d=> d?.ok && setServerPhotos(d.photos || []));
  }, [photoStorage, property]);

  const [rentItems, setRentItems] = useState(property?.rent_items ?? []);

  const tableWrapRef = useRef(null);
  const midSectionRef = useRef(null);     // 첫 장 임대현황 섹션 참조
  const supplierRef = useRef(null);
  const [firstPageCount, setFirstPageCount] = useState(Number.POSITIVE_INFINITY);

  /** 1쪽에 들어갈 수 있는 임대행 개수 측정 */
  const measureFirstPageRows = () => {
    const wrap = tableWrapRef.current;
    if (!wrap) return;

    // 헤더 높이 포함
    const header = wrap.querySelector("thead");
    const headerH = header?.offsetHeight || 0;

    // 사용 가능한 높이 = 임대표 영역 높이 - (공급자정보가 차지할 예상 높이)
    const supplierH = supplierRef.current?.clientHeight || 0;
    const gap = 10; // 섹션 간 여백 보정
    const avail = Math.max(0, wrap.clientHeight - supplierH - gap - headerH);
    if (!avail || !Number.isFinite(avail)) return;

    // 실제 렌더된 tr들 높이 합산
    const rows = wrap.querySelectorAll("tbody > tr");
    let sum = 0;
    let cnt = 0;
    for (const tr of rows) {
      const h = tr.offsetHeight || 0;
      if (sum + h > avail) break;
      sum += h;
      cnt++;
    }

    // 음수일수록 1쪽에 더 많이 넣는다(cnt - (-N) = cnt + N).
    // 너무 키우면 지면을 넘긴 행이 잘려 사라지므로 1씩 올리며 확인할 것.
    const safetyMargin = -6;
    setFirstPageCount(Math.max(0, cnt - safetyMargin));
  };

  // 팝업 열릴 때, 데이터 바뀔 때, 리사이즈 시 재측정
  useEffect(() => {
    const rerun = () => requestAnimationFrame(measureFirstPageRows);
    rerun();
    window.addEventListener("resize", rerun);
    return () => window.removeEventListener("resize", rerun);
  }, [open, rentItems]);

  useEffect(() => {
    const pid = property?.id || property?.estate_no;
    if (!pid) return;
    fetch(`/api/properties/${pid}/rent-items`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(d => { if (d?.ok && Array.isArray(d.items)) setRentItems(d.items); })
      .catch(() => {});
  }, [open, property]);

  // === 임대현황 헬퍼 ===
  const ESTATE_TYPES = [
    { value: "residence", label: "주거용" },
    { value: "business",  label: "업무용" },
    { value: "commerce",  label: "상업용" },
  ];

  const labelOf = v => ESTATE_TYPES.find(o=>o.value===v)?.label ?? "";
  const yn = v => String(v||"").toLowerCase()==="y";
  const sumByUsage = (items)=>{
    const total = items.length;
    const resCnt = items.filter(it=>it.estate_type==="residence").length;
    const nonCnt = total - resCnt;
    return { total, resCnt, nonCnt };
  };

  const { total:rentTotal, resCnt, nonCnt } = useMemo(
    () => sumByUsage(rentItems),
    [rentItems]
  );

  const [editRent, setEditRent] = useState(false);

  const addRent = ()=> setRentItems(prev=>[...prev, {
    unitNo:"", estate_type:"", type:"", deposit:"", monthly:"", mgmtFee:"", note:""
  }]);
  const updRent = (idx, key, val)=> setRentItems(prev=> prev.map((r,i)=> i===idx? {...r,[key]:val} : r));
  const delRent = (idx)=> setRentItems(prev=> prev.filter((_,i)=> i!==idx));

  const cardRef = useRef(null);

  // 높이 초과 시 자동 축소
  const autoShrink = () => {
    const root = cardRef.current;
    if (!root) return;
    const outers = root.querySelectorAll(".memo-col .fit-outer");
    outers.forEach(outer => {
      const inner = outer.querySelector(".fit-inner");
      if (!inner) return;
      inner.style.transform = "scale(1)";
      const reserve = 4;
      const avail = outer.getBoundingClientRect().height - reserve;
      const need  = inner.scrollHeight;
      if (avail > 0 && need > avail) {
        const scale = Math.max(0.6, avail / need);
        inner.style.transform = `scale(${scale})`;
      }
    });
  };

  // rAF 디바운스 실행기
  let rafId = null;
  const shrink = (fn) => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      fn();
      rafId = null;
    });
  };

  useEffect(() => {
    shrink(autoShrink);
    const onRz = () => shrink(autoShrink);
    window.addEventListener("resize", onRz);
    return () => window.removeEventListener("resize", onRz);
  }, [open, property]);

  // 공통: 첫 번째 유효값 선택
  const pick = (...vals) => {
    for (const v of vals) {
      if (v == null) continue;
      const s = String(v).trim();
      if (s && s.toLowerCase() !== "null" && s.toLowerCase() !== "undefined") return s;
    }
    return "";
  };

  const toNum = (v) => {
    const n = Number(String(v||"").replace(/[, ]/g,""));
    return Number.isFinite(n) ? n : 0;
  };

  const fmt = (n)=> new Intl.NumberFormat("ko-KR").format(n);
  const udMap = useMemo(()=>({
    ud11:"제1종전용주거지역", ud12:"제2종전용주거지역",
    ud13:"제1종일반주거지역", ud14:"제2종일반주거지역", ud15:"제3종일반주거지역",
    ud21:"준주거지역", ud22:"중심상업지역", ud23:"일반상업지역", ud24:"근린상업지역", ud25:"유통상업지역",
    ud26:"전용공업지역", ud27:"준공업지역", ud31:"전용공업지역", ud32:"일반공업지역",
    ud33:"보전녹지지역", ud34:"생산녹지지역", ud35:"자연녹지지역",
    ud36:"보전관리지역", ud37:"생산관리지역", ud38:"계획관리지역",
  }), []);

  // 첫 사진 후보
  const basePhotos = useMemo(() => {
    const out = [];
    const push = (v)=>{ const s=String(v||"").trim(); if(s) out.push(s); };
    if (Array.isArray(property?.images)) out.push(...property.images.filter(Boolean));
    if (Array.isArray(property?.photos)) out.push(...property.photos.filter(Boolean));
    const csv = property?.image_urls || property?.images_csv || property?.photo_urls;
    if (csv) out.push(...String(csv).split(",").map(s=>s.trim()).filter(Boolean));
    for (let i=1;i<=10;i++){ push(property?.[`photo${i}`]); push(property?.[`image${i}`]); }
    return [...new Set(out)];
  }, [property]);

// 2) 사진(미리보기) 초기 세팅: DB thumb_file_id → 로컬 → 기존
// 매물 변경 또는 모달 오픈 시 초기화
useEffect(() => {
  if (!open) return;
  const curr = property || null;
  setPropState(curr);
  const url = curr ? pickUrl(curr, "") : "";
  setPhotoUrl(url || "");
}, [open, property?.estate_no, property?.id, pickUrl]);

// 사진 변경 시 로컬 보관
useEffect(() => {
  const pid = property?.id || property?.estate_no;
  if (!pid || !photoUrl) return;
  localStorage.setItem(`print.photo.${pid}`, photoUrl);
}, [photoUrl, property]);

  const canon = (s) => String(s||"").trim();
  const norm  = (s) => canon(s).toLowerCase().replace(/[_\s]+/g, "-");

  const bldTypeName = useMemo(() => {
    const raw = canon(property?.bld_type ?? property?.estate_type ?? "");
    const keys = [raw, raw.toLowerCase(), norm(raw)];
    for (const k of keys) {
      const v = BLD_TYPE_LABELS?.[k];
      if (v) return v;
    }
    return raw || "건물";
  }, [property?.bld_type, property?.estate_type]);

  const nameTitle = useMemo(() =>
    pick(
      property?.estate_name, property?.bld_name, property?.building_name, property?.shop_name, property?.title,
      bldTypeName, "건물"
    ), [property, bldTypeName]
  );

  const jibunAddr = useMemo(() => {
    const j = pick(
      property?.jibunAddress, property?.jibun_address, property?.jibunaddress,
      property?.addr_jibun, property?.address_jibun,
      (property?.dong && property?.jibun ? `${property.dong} ${property.jibun}` : null),
      property?.jibun
    );
    return j || "-";
  }, [property]);

  const roadAddr = useMemo(() => {
    const r = pick(property?.roadAddress, property?.road_address, property?.addr_road, property?.address_road, property?.road_addr);
    return r || "-";
  }, [property]);

  // 파일 업로드 핸들러 (setForm 미정의인 환경이면 사용하지 말 것)
  const onUploadWatermark = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch("/api/uploads/watermark", { method: "POST", body: fd });
    if (!res.ok) { alert("업로드 실패"); return; }
    const { url } = await res.json();
    // setForm(f => ({ ...f, wmUrl: url }));
  };

  // 금액·면적 후보 체인
  const priceSale = useMemo(
    () => toNum(property?.price_sale ?? pick(property?.price, property?.deal_price, property?.price_sum)),
    [property?.price_sale, property?.price, property?.deal_price, property?.price_sum]
  );

  const rentTotals = useMemo(() => {
    let deposit = 0, monthly = 0, mgmt = 0;
    for (const r of rentItems || []) {
      deposit += toNum(r.deposit);
      monthly += toNum(r.monthly);
      mgmt    += toNum(r.mgmtFee);
    }
    return { deposit, monthly, mgmt };
  }, [rentItems]);

  const totalDeposit = useMemo(() => {
    const modal = rentTotals.deposit;
    const saleType = toNum(property?.sale_type_rent_year);
    const feeYear = toNum(property?.fee_year);
    if (modal > 0) return modal;
    if (saleType > 0) return saleType;
    return feeYear;
  }, [rentTotals.deposit, property?.sale_type_rent_year, property?.fee_year]);

  const totalMonthly = useMemo(() => {
    const modal = rentTotals.monthly;
    const saleType = toNum(property?.sale_type_rent_month);
    const feeMonth = toNum(property?.fee_month);
    if (modal > 0) return modal;
    if (saleType > 0) return saleType;
    return feeMonth;
  }, [rentTotals.monthly, property?.sale_type_rent_month, property?.fee_month]);

  const totalMgmt = useMemo(() => {
    const modal = rentTotals.mgmt;
    const fMgr  = toNum(property?.f_price_total_mgr);
    const perHousehold = toNum(property?.price_per_household);
    const cnt   = toNum(property?.rent_household_cnt);
    if (modal > 0) return modal;
    if (fMgr > 0) return fMgr;
    return perHousehold * cnt;
  }, [rentTotals.mgmt, property?.f_price_total_mgr, property?.price_per_household, property?.rent_household_cnt]);

  const landM2    = pick(property?.site_scale, property?.site_amount, property?.land_area, property?.site_area);
  const landPy    = pick(property?.site_scale_square, property?.site_amount_square, property?.land_area_py);
  const approval  = pick(property?.use_approval_date, property?.completion_year, property?.permission_detail, property?.permission_type);
  const useDistrictName = pick(udMap[String(property?.use_district || "").trim()], property?.use_district);

  const mortgage  = useMemo(()=> toNum(property?.mortgage), [property?.mortgage]);

  const realInvest = useMemo(() => {
    const prop = toNum(property?.price_investment);
    if (prop > 0) return prop;
    return Math.max(priceSale - totalDeposit - mortgage, 0);
  }, [property?.price_investment, priceSale, totalDeposit, mortgage]);

  const yearlyRate = useMemo(() => {
    const r = toNum(property?.f_interest_loan);
    return r > 1 ? r/100 : r;
  }, [property?.f_interest_loan]);

  const pid = property?.id ?? property?.estate_no ?? "";
  const miscKey = `print.miscCost.${pid}`;
  const [miscLabel, setMiscLabel] = useState("");
  const [miscAmount, setMiscAmount] = useState(0);
  const [showMiscLayer, setShowMiscLayer] = useState(false);
  const miscBtnRef = useRef(null);
  const miscLayerRef = useRef(null);

  const saveMisc = () => { localStorage.setItem(miscKey, String(miscAmount||0)); setShowMiscLayer(false); };

  // 메모 상태
  const memoKey = `print.memo.${pid}`;
  const [memo, setMemo] = useState(() => localStorage.getItem(memoKey) || "");
  const memoRef = useRef(null);
  const lastValidMemoRef = useRef(memo);
  useEffect(() => {
    // [MEMO_NEWLINE_V1] contentEditable 은 엔터를 <div>/<br> 로 만든다.
    //   textContent 는 요소 경계를 무시해 줄바꿈이 사라지므로 읽기는 innerText 를 쓴다.
    if (memoRef.current && memoRef.current.innerText !== (memo || "")) {
      memoRef.current.textContent = memo || "";
    }
  }, [open]);

  // 모달 열릴 때 DB에서 메모 불러오기
  useEffect(() => {
    const pid = property?.id || property?.estate_no;
    if (!open || !pid) return;
    fetch(`/api/properties/${pid}/rent-memo`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(d => {
        if (d?.ok) {
          // [MEMO_PRESET_V1] 저장된 메모가 없으면 주차·승강기 정보를 기본값으로 채운다.
          //   줄바꿈(\n)은 .memo-editable 의 white-space:pre-wrap 이 렌더한다.
          //   이미 저장된 메모가 있으면 손대지 않는다.
          const pkCnt = Number(property?.parking_cnt) || 0;
          const hasEv = String(property?.living_condition_ev || "").toLowerCase() === "y";
          const preset = [
            pkCnt > 0 ? `주차 ${pkCnt}대` : "주차불가",
            hasEv ? "승강기 있음" : "승강기 없음",
          ].join("\n");
          const v = d.memo || preset;
          setMemo(v);
          lastValidMemoRef.current = v;
          if (memoRef.current) memoRef.current.textContent = v;
        }
      })
      .catch(()=>{ /* 무시 */ });
  }, [open, property]);

  // 모달 열릴 때 DB에서 월비용 불러오기
  useEffect(() => {
    const pid = property?.id || property?.estate_no;
    if (!open || !pid) return;
    fetch(`/api/properties/${pid}/rent-misc`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(d => {
        if (d?.ok) {
          setMiscLabel(d.misc_label || "");
          setMiscAmount(Number(d.misc_amount || 0));
        }
      })
      .catch(()=>{});
  }, [open, property]);

  useEffect(() => {
    const el = cardRef.current?.querySelector(".memo-col .fit-outer");
    if (!el) return;
    const ro = new ResizeObserver(() => shrink(autoShrink));
    ro.observe(el);
    return () => ro.disconnect();
  }, [open, property]);

  // 레이어 외부 클릭 시 저장 후 닫기
  useEffect(() => {
    if (!showMiscLayer) return;
    const onDown = async (e) => {
      const insideLayer = miscLayerRef.current && miscLayerRef.current.contains(e.target);
      const onButton = miscBtnRef.current && miscBtnRef.current.contains(e.target);
      if (insideLayer || onButton) return;
      const pid = property?.id || property?.estate_no; if (pid) {
        try {
          await fetch(`/api/properties/${pid}/rent-misc`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ misc_label: miscLabel, misc_amount: miscAmount })
          });
        } catch {}
      }
      setShowMiscLayer(false);
    };
    document.addEventListener("mousedown", onDown, true);
    return () => document.removeEventListener("mousedown", onDown, true);
  }, [showMiscLayer, miscLabel, miscAmount, property]);

  useEffect(() => { shrink(autoShrink); }, [memo]);

  const [memoOpen, setMemoOpen] = useState(false);
  const saveMemo = () => { localStorage.setItem(memoKey, memo || ""); setMemoOpen(false); };

  const monthlyLoan = useMemo(()=> mortgage > 0 ? Math.round((mortgage * yearlyRate) / 12) : 0, [mortgage, yearlyRate]);
  const monthlyCost = useMemo(()=> monthlyLoan + (miscAmount||0), [monthlyLoan, miscAmount]);

  // 8) 월수익 = 총월세 + 총관리비 - 월비용
  const monthlyIncome = useMemo(()=> totalMonthly + totalMgmt - monthlyCost, [totalMonthly, totalMgmt, monthlyCost]);

  const center = useMemo(() => {
    const lat = Number(property?.lat);
    const lng = Number(property?.lng);
    return {
      lat: Number.isFinite(lat) ? lat : 37.5665,
      lng: Number.isFinite(lng) ? lng : 126.9780,
      level: 4,
    };
  }, [property]);

  // 워터마크 불러오기
  const [wm, setWm] = useState({ url:"", opacity:0.08 });
  const clamp = (v)=> Math.max(0, Math.min(1, v));
  // 1) 워터마크는 전역 설정만 사용(URL + 불투명도 모두 /api/config)
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await fetch("/api/config");
        const cfg = await r.json();
      const url = cfg?.watermark_url || "";
      const op  = Number.parseFloat(cfg?.watermark_opacity ?? "0.08");
      const opacity = Number.isFinite(op) ? clamp(op) : 0.08;
      if (mounted) setWm(prev => ({ ...prev, url, opacity }));
      } catch {}
    })();
    return () => { mounted = false; };
  }, []);

  // DB 썸네일이 있으면 워터마크 기본값으로도 사용
// 3) app config가 비어있을 때만 DB 썸네일을 워터마크로 보조 적용
useEffect(() => {
  if (!wm.url && property?.thumb_file_id) {
    const url = `https://drive.google.com/uc?export=view&id=${property.thumb_file_id}`;
    setWm(prev => ({ ...prev, url }));
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [property?.thumb_file_id]);

  <label className="btn">
    워터마크 업로드 {uploading ? "(업로드중)" : ""}
    <input type="file" accept="image/*" onChange={onWatermarkFile} hidden />
  </label>

  const onPrint = () => {
    // 첫 장 임대현황 "상자" 높이 고정 → 레이아웃 보존
    const box = midSectionRef.current;
    if (box) {
      const h = box.clientHeight;
      if (h) box.style.minHeight = `${h}px`;
    }
    // 내부 테이블 래퍼도 보조 고정
    const h2 = tableWrapRef.current?.clientHeight;
    if (h2) tableWrapRef.current.style.minHeight = `${h2}px`;

    autoShrink();
    const a4 = cardRef.current?.querySelector(".a4");
    if (!a4) return;
    const placeholder = document.createComment("PRINT-PLACEHOLDER");
    const parent = a4.parentNode;
    parent.insertBefore(placeholder, a4);
    a4.classList.add("printing-now");
    document.body.setAttribute("data-print-only", "1");
    document.body.appendChild(a4);

    const restore = () => {
      if (midSectionRef.current) midSectionRef.current.style.minHeight = "";
      if (tableWrapRef.current) tableWrapRef.current.style.minHeight = "";
      try {
        placeholder.parentNode?.insertBefore(a4, placeholder);
        placeholder.remove();
      } catch {}
      a4.classList.remove("printing-now");
      document.body.removeAttribute("data-print-only");
      window.removeEventListener("afterprint", restore);
    };
    window.addEventListener("afterprint", restore);
    window.print();
    setTimeout(restore, 2000);
  };

  if (!open || !property) return null;

  return (
    <div className="print-modal" role="dialog" aria-modal="true">
      <div className="print-card" ref={cardRef}>
        {/* A4 컨테이너 */}
        <div className="a4">
          {/* 워터마크: 인쇄시에 .a4만 추출되므로 내부로 이동 */}
          {wm.url && (
            <img
              src={wm.url}
              alt=""
              className="print-watermark"
              style={{ opacity: wm.opacity }}
            />
          )}

          {/* 상단 1/3: 좌 지도, 중 사진, 우 기본정보 */}
          <div className="row top row-thirds">
            <div className="col third map">
              <div className="map-box">
                <StaticMapBox center={center} />
              </div>
            </div>

            <div className="col third photo">
              <div style={{ width: "100%", height: 240 /* 필요 높이로 변경 */ }}>
                <PhotoSlot
                  key={(propState?.estate_no ?? propState?.id ?? property?.estate_no ?? property?.id) || 'none'}
                  propertyId={Number((propState?.estate_no ?? propState?.id ?? property?.estate_no ?? property?.id) ?? 0)}
                  value={photoUrl}
                  onChange={setPhotoUrl}
                  onUploadState={setUploading}                // ← 시작/종료 신호 수신
                  onUploaded={(meta) => {
                    // DB 업데이트 직후 로컬에도 반영해서 즉시 일관성 유지
                    if (meta && (meta.thumb_url || meta.thumb_file_id)) {
                      const next = {
                        ...(propState || property || {}),
                        thumb_url: meta.thumb_url || (propState?.thumb_url || property?.thumb_url),
                        thumb_file_id: meta.thumb_file_id || (propState?.thumb_file_id || property?.thumb_file_id),
                      };
                      setPropState(next);
                      // 표시 URL도 즉시 교체
                      const base = next.thumb_url || (next.thumb_file_id ? `/api/photo-storage/${next.thumb_file_id}/preview` : "");
                      if (base) setPhotoUrl(`${base}${base.includes('?') ? '&' : '?'}t=${Date.now()}`);
                      // 리스트 즉시 갱신 통지
                      const eid = Number(next.estate_no ?? next.id ?? property?.estate_no ?? property?.id ?? 0);
                      if (onUpdated && eid > 0) {
                        onUpdated({ estate_no: eid, thumb_url: next.thumb_url || "", thumb_file_id: next.thumb_file_id || "" });
                      }
                      setUploading(false);                    // 완료 전환
                    }
                  }}
                />
              </div>
            </div>
            
            <div className="col third info fit-outer">
              <div className="fit-inner">
                <h1 className="bname">{nameTitle || "건물"}</h1>
                <div className="kv"><b>{bldTypeName}</b></div>
                <div className="kv kv-addr"><b>{jibunAddr}<br/>{roadAddr}</b></div>
                <div className="kv"><b>{approval} 준공</b></div>
                <div className="kv"><b>대지 {landM2}㎡ ({landPy} 평)</b></div>
                <div className="kv kv-scale">
                  <b>{property.bld_scale || ""}층{property.bld_scale_under ? ` / 지하${property.bld_scale_under}`:""}</b>
                  {useDistrictName && <span className="ud-badge">{useDistrictName}</span>}
                </div>
                {String(property?.living_condition_ev||"").toLowerCase()==="y" && (
                  <div className="kv"><b style={{ color: "blue" }}>승강기</b></div>
                )}
              </div>
            </div>
          </div>

          {/* 금액 블록 */}
          <div className="section amount fit-outer">
            <div className="fit-inner">
              <div className="amount-three">
                <div className="col">
                  <div className="kv"><span>①매매금액</span><b>{fmt(priceSale)}</b></div>
                  <div className="kv"><span>②총보증금</span><b>{fmt(totalDeposit)}</b></div>
                  <div className="kv"><span>③대출</span><b>{mortgage>0?fmt(mortgage):"-"}</b></div>
                  <div className="kv"><span>①-②-③실투자금</span><b>{fmt(realInvest)}</b></div>
                </div>
                <div className="col">
                  <div className="kv"><span>①총월세</span><b>{fmt(totalMonthly)}</b></div>
                  <div className="kv"><span>②총관리비</span><b>{fmt(totalMgmt)}</b></div>
                  <div className="kv kv-monthcost">
                    <span>③월비용</span>
                    <b>
                      <span
                        className="misc-edit"
                        role="button"
                        tabIndex={0}
                        ref={miscBtnRef}
                        onClick={()=> setShowMiscLayer(true)}
                        onKeyDown={(e)=>{ if(e.key==='Enter') setShowMiscLayer(true); }}
                      >
                        {fmt(miscAmount)}
                      </span>
                    </b>
                    {showMiscLayer && (
                      <div
                        className="misc-layer"
                        ref={miscLayerRef}
                        onKeyDown={async (e)=>{
                          if (e.key === "Escape") { setShowMiscLayer(false); return; }
                          if (e.key === "Enter") {
                            const pid = property?.id || property?.estate_no; if (!pid) return;
                            try {
                              await fetch(`/api/properties/${pid}/rent-misc`, {
                                method: "PUT",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ misc_label: miscLabel, misc_amount: miscAmount })
                              });
                            } catch {}
                            setShowMiscLayer(false);
                          }
                        }}
                      >
                        <label>항목</label>
                        <input
                          type="text"
                          value={miscLabel}
                          onChange={e=> setMiscLabel(e.target.value)}
                          autoFocus
                        />
                        <label>금액</label>
                        <input
                          type="number" inputMode="numeric"
                          value={miscAmount}
                          onChange={e=> setMiscAmount(toNum(e.target.value))}
                          onBlur={async ()=>{
                            const pid = property?.id || property?.estate_no; if (!pid) return;
                            try {
                              await fetch(`/api/properties/${pid}/rent-misc`, {
                                method: "PUT",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ misc_label: miscLabel, misc_amount: miscAmount })
                              });
                            } catch {}
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="kv"><span>①+②-③월수익</span><b>{fmt(monthlyIncome)}</b></div>
                </div>
                <div className="col memo-col">
                  <div className="memo-body fit-outer">
                    <div className="fit-inner">
                      <div
                        ref={memoRef}
                        className="memo-editable"
                        contentEditable
                        suppressContentEditableWarning
                        role="textbox"
                        aria-multiline="true"
                        onInput={(e)=>{
                          const el = e.currentTarget;
                          const root = cardRef.current;
                          const outer = root?.querySelector(".memo-col .fit-outer");
                          const inner = root?.querySelector(".memo-col .fit-inner");
                          const val = el.innerText || "";
                          if (!outer || !inner) { lastValidMemoRef.current = val; setMemo(val); return; }
                          const prev = inner.style.transform;
                          inner.style.transform = "scale(1)";
                          const reserve = 4;
                          const avail = outer.getBoundingClientRect().height - reserve;
                          const need  = inner.scrollHeight;
                          const scale = avail > 0 ? avail / need : 1;
                          inner.style.transform = prev;
                          if (scale < 0.6) {
                            el.textContent = lastValidMemoRef.current || "";
                            const sel = window.getSelection(); const range = document.createRange();
                            range.selectNodeContents(el); range.collapse(false);
                            sel.removeAllRanges(); sel.addRange(range);
                            return;
                          }
                          lastValidMemoRef.current = val;
                          setMemo(val);
                        }}
                        onBlur={async ()=>{
                          const pid = property?.id || property?.estate_no;
                          if (!pid) return;
                          try {
                            const res = await fetch(`/api/properties/${pid}/rent-memo`, {
                              method: "PUT",
                              headers: { "Content-Type": "application/json" },
                              body: JSON.stringify({ memo })
                            });
                            if (!res.ok) throw new Error("fail");
                          } catch(e) {
                            console.error("메모 저장 실패", e);
                          }
                        }}
                      />
                      {!memo && !memoRef.current?.innerText && (
                        <span className="memo-placeholder">↑↑↑ 클릭하여 메모 입력</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 임대현황 블럭 (fit-inner 내부) */}
          <div className="section mid fit-outer" ref={midSectionRef}>
            <div className="fit-inner">
              {/* 헤더 요약 */}
              <div className="rent-status-header">
                <div className="left"><strong>임대현황</strong></div>
                <div className="right">
                  <span>전체 {rentTotal} 가구</span>
                  <span className="dot">·</span>
                  <span>주거용 {resCnt}</span>
                  <span className="dot">·</span>
                  <span>주거외 {nonCnt}</span>
                  {yn(property?.owner_household) && (
                    <span className="owner-badge">주인세대 {property?.owner_room ?? "-"}룸 / {property?.owner_bath ?? "-"}욕실</span>
                  )}
                </div>
              </div>

              {/* 액션 */}
              <div className="rent-status-actions">
                {!editRent ? (
                  <button type="button" className="btn" onClick={()=>setEditRent(true)}>수정</button>
                ) : (
                  <>
                    <button type="button" className="btn" onClick={addRent}>행 추가</button>
                    <button type="button" className="btn" onClick={async ()=>{
                      // property id 없으면 바로 종료
                      if (!property?.id && !property?.estate_no) {
                        alert("property id 없음");
                        return;
                      }
                      try {
                        const res = await saveRentItems(
                          property.id || property.estate_no,
                          rentItems,
                          memo
                        );
                        // ✅ 서버가 count 또는 saved 로 반환할 수 있어서 둘 다 대응
                        const savedCount = res.count ?? res.saved ?? "?";
                        alert("저장 완료: " + savedCount + "건");
                        setEditRent(false);
                      } catch (e) {
                        // ✅ 수정 전: alert("저장 실패")  ← 원인을 전혀 알 수 없음
                        // ✅ 수정 후: 실제 오류 메시지를 보여줌
                        console.error("[saveRentItems 실패]", e);
                        alert("저장 실패: " + e.message);  // ← 이게 핵심 수정
                      }
                    }}>저장</button>
                  </>
                )}
              </div>

              {/* 표 */}
              <div className="rent-status-tablewrap" ref={tableWrapRef}>
                <table className="rent-status-table">
                  <thead>
                    <tr>
                      <th>호수</th>
                      <th>용도</th>
                      <th>형태</th>
                      <th className="num">보증금</th>
                      <th className="num">월세</th>
                      <th>관리비</th>
                      <th>비고</th>
                      {editRent && <th className="narrow">삭제</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {rentItems.length===0 ? (
                      <tr><td colSpan={editRent?8:7} className="empty">등록된 임대내역이 없습니다.</td></tr>
                    ) : rentItems.map((r,idx)=>(
                      <tr key={idx} className={idx >= firstPageCount ? "rent-row-overflow" : ""}>
                        <td>{editRent ? <input value={r.unitNo||""} onChange={e=>updRent(idx,"unitNo",e.target.value)} /> : r.unitNo}</td>
                        <td>
                          {editRent ? (
                            <select value={r.estate_type||""} onChange={e=>updRent(idx,"estate_type",e.target.value)}>
                              <option value="">선택</option>
                              {ESTATE_TYPES.map(o=> <option key={o.value} value={o.value}>{o.label}</option>)}
                            </select>
                          ) : labelOf(r.estate_type)}
                        </td>
                        <td>{editRent ? <input value={r.type||""} onChange={e=>updRent(idx,"type",e.target.value)} /> : r.type}</td>
                        <td className="num">{editRent ? <input value={r.deposit||""} onChange={e=>updRent(idx,"deposit",e.target.value)} /> : fmt(toNum(r.deposit))}</td>
                        <td className="num">{editRent ? <input value={r.monthly||""} onChange={e=>updRent(idx,"monthly",e.target.value)} /> : fmt(toNum(r.monthly))}</td>
                        <td>{editRent ? <input value={r.mgmtFee||""} onChange={e=>updRent(idx,"mgmtFee",e.target.value)} /> : r.mgmtFee}</td>
                        <td>{editRent ? <input value={r.note||""} onChange={e=>updRent(idx,"note",e.target.value)} /> : r.note}</td>
                        {editRent && (
                          <td className="narrow">
                            <button type="button" className="btn danger" onClick={()=>delRent(idx)}>삭제</button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* 공급자 정보 */}
          <div className="supplier-block" ref={supplierRef}>
            <SupplierInfoBlock />
          </div>

          {/* 인쇄 전용: 이어서 출력(2장부터 시작) */}
          {Number.isFinite(firstPageCount) && rentItems.length > firstPageCount && (
            <div className="print-only rent-continue-page">
              <div className="section mid fit-outer">
                <div className="fit-inner">
                  <div className="rent-status-tablewrap">
                    <table className="rent-status-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th>호수</th><th>용도</th><th>형태</th>
                          <th className="num">보증금</th><th className="num">월세</th><th>관리비</th><th>비고</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rentItems.slice(firstPageCount).map((r, idx) => (
                          <tr key={`cont-${firstPageCount + idx}`}>
                            <td>{r.unitNo}</td>
                            <td>{labelOf(r.estate_type)}</td>
                            <td>{r.type}</td>
                            <td className="num">{fmt(toNum(r.deposit))}</td>
                            <td className="num">{fmt(toNum(r.monthly))}</td>
                            <td>{r.mgmtFee}</td>
                            <td>{r.note}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>

      <div className="print-toolbar">
        <button type="button" onClick={onClose}>닫기</button>
        <button type="button" onClick={onPrint}>출력</button>
      </div>
    </div>
  );
}
